import axios from 'axios';
import { setError } from './globalActions';
import Api from '../Config';

export const getNav = nav => ({
  type: 'GET_NAV',
  nav,
});

export const setSubcategories = subcategories => ({
  type: 'SET_SUBCATEGORIES',
  subcategories,
});

export const setActiveCategoryId = categoryId => ({
  type: 'SET_ACTIVE_CATEGORY_ID',
  activeCategoryId: categoryId,
});


export const setActiveCategory = category => ({
  type: 'SET_ACTIVE_CATEGORY',
  activeCategory: category,
});

export const setActiveSubCategories = subcategories => ({
  type: 'SET_ACTIVE_SUBCATEGORIES',
  activeSubCategories: subcategories,
});

export const fetchNav = lang => (dispatch) => {
  axios.get(`${Api.base + lang}/${Api.nav}`).then((response) => {
    const data = response.data;
    dispatch(getNav(data));
    // set inital subcategory
    dispatch(setSubcategories(data['main-navigation'][0].items));
    dispatch(setActiveCategoryId(data['main-navigation'][0].id));
    dispatch(setActiveCategory(data['main-navigation'][0]));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/navActions.jsx